import React, { useState } from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import Input from "aldoo-ra/Input"

const FeedbackDialog = ({ isOpen, onClose, onContinue }) => {
  const [feedback, setFeedback] = useState("")

  const texts = TextBundle({ id: "cancellation_feedback_dialog" })

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value)
  }

  const handleContinue = () => {
    onContinue(feedback)
  }

  const isButtonDisabled = !feedback.trim()

  return (
    <Modal
      title={texts?.title}
      isOpen={isOpen}
      onClose={onClose}
      variant="aqua_medium"
      className="md:max-w-[575px]"
    >
      <div className="max-w-[500px] md:max-w-full space-y-8 pt-10 md:pt-4 mx-auto md:mx-0">
        <Typography
          variant="info_18" 
          className="text-text text-center md:text-left my-0"
        >
          {texts?.subtitle}
        </Typography>

        <Input
          multiline
          autoFocus
          value={feedback}
          onChange={handleFeedbackChange}
          placeholder={texts?.feedback_placeholder}
          variant="aqua_input"
          className="w-full"
          styleOverrides={{
            textarea: "h-32 resize-none p-4 focus:outline-none focus:ring-0",
            input_wrapper: "border border-gray_3 rounded-[24px] focus-within:border-primary transition-colors overflow-hidden",
          }}
        />
        <div className="flex justify-center md:justify-end">
          <Button
            variant="secondary_s"
            onClick={handleContinue}
            disabled={isButtonDisabled}
          >
            {texts?.cta_button_text}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default FeedbackDialog
